import { useSubscription } from 'urql';

export default useSubscription;
